import {IRingBuffer, useRingBuffer} from "../../../hooks/useRingBuffer";
import {ChatMessage} from "../interfaces";
import {createContext, ReactNode, useContext} from "react";
import {useRPC, useSocket} from "../SocketContext";
import {useEvent} from "../../../hooks/useEvent";
import {rpc_chatInit} from "../rpc";

const Context = createContext<ChatContextData>(null!);

export default function ChatContext(props: {children: ReactNode}) {
    const socket = useSocket()

    const messages = useRingBuffer<ChatMessage>(1_000)

    useEvent("socketOpen", () => {
        rpc_chatInit(socket, 1_000, "0", 0, -1).then(init => {
            if (init){
                messages.clear()
                messages.add(...init.messages)
            }
        })
    })

    useRPC(socket, "OnChatMessage", (message: ChatMessage) => {
        console.log("OnChatMessage", message)
        messages.add(message);
    })

    const context = {
        messages
    }

    return (
        <Context.Provider value={context}>
            {props.children}
        </Context.Provider>
    )
}

export const useChat = () => useContext(Context)

interface ChatContextData{
    messages:  IRingBuffer<ChatMessage>
}